import { useLazyQuery } from "@apollo/client";
import { IPendingInvoices } from "./delinquent-payment.interface";
import { PENDING_INVOICES_BY_ID } from "./delinquent-payment.query";

export const useGetPendingInvoiceById = () => {
  const [getPendingInvoicesById, { loading, data }] =
  useLazyQuery<{ pendingInvoicesByPetId: IPendingInvoices }>(PENDING_INVOICES_BY_ID);

  const getOverdueInvoices = (id: string) => {
    getPendingInvoicesById({
      variables: {
        petId: id,
      },
      fetchPolicy: "network-only",
    });
  };

  return {
    getOverdueInvoices,
    loading,
    pendingInvoices: data?.pendingInvoicesByPetId?.pendingSquareInvoices,
  };
};
